/**
 * @flow
 * @relayHash 9b522e76e0caae61d937eddbaf757e3a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ArticleList_viewer$ref = any;
export type ArticleStateType = "available" | "deleted" | "draft" | "%future added value";
export type ArticleList_Refetch_QueryVariables = {|
  page: number,
  blockSlug: string,
  section: string,
  search?: ?string,
  states?: ?$ReadOnlyArray<?ArticleStateType>,
|};
export type ArticleList_Refetch_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: ArticleList_viewer$ref
  |}
|};
export type ArticleList_Refetch_Query = {|
  variables: ArticleList_Refetch_QueryVariables,
  response: ArticleList_Refetch_QueryResponse,
|};
*/


/*
query ArticleList_Refetch_Query(
  $page: Int!
  $blockSlug: String!
  $section: ID!
  $search: String
  $states: [ArticleStateType]
) {
  viewer {
    ...ArticleList_viewer_NlpIG
    id
  }
}

fragment ArticleList_viewer_NlpIG on Viewer {
  configurableBlock(slug: $blockSlug) {
    id
    type
    slug
    config
    active
  }
  articles: articlesPaginate(pageSize: 12, page: $page, plainSearch: $search, section: $section, states: $states) {
    totalCount
    articles {
      ...ArticleListItem_article
      id
    }
  }
}

fragment ArticleListItem_article on Article {
  id
  section
  title
  authorName
  categoryName
  availableAt
  hidden
  isArticleOfDay
  isArticleOfHour
  isEvent
  state
  mainPageOrder
  showInYandexNews
  showInYandexZen
  infostring
  infostring_hot
  mediaFiles {
    id
  }
  preview {
    type
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "page",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "blockSlug",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "section",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "states",
    "type": "[ArticleStateType]",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ArticleList_Refetch_Query",
  "id": null,
  "text": "query ArticleList_Refetch_Query(\n  $page: Int!\n  $blockSlug: String!\n  $section: ID!\n  $search: String\n  $states: [ArticleStateType]\n) {\n  viewer {\n    ...ArticleList_viewer_NlpIG\n    id\n  }\n}\n\nfragment ArticleList_viewer_NlpIG on Viewer {\n  configurableBlock(slug: $blockSlug) {\n    id\n    type\n    slug\n    config\n    active\n  }\n  articles: articlesPaginate(pageSize: 12, page: $page, plainSearch: $search, section: $section, states: $states) {\n    totalCount\n    articles {\n      ...ArticleListItem_article\n      id\n    }\n  }\n}\n\nfragment ArticleListItem_article on Article {\n  id\n  section\n  title\n  authorName\n  categoryName\n  availableAt\n  hidden\n  isArticleOfDay\n  isArticleOfHour\n  isEvent\n  state\n  mainPageOrder\n  showInYandexNews\n  showInYandexZen\n  infostring\n  infostring_hot\n  mediaFiles {\n    id\n  }\n  preview {\n    type\n    id\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ArticleList_Refetch_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ArticleList_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "blockSlug",
                "variableName": "blockSlug",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "page",
                "variableName": "page",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "search",
                "variableName": "search",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "section",
                "variableName": "section",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "states",
                "variableName": "states",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ArticleList_Refetch_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "configurableBlock",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "slug",
                "variableName": "blockSlug",
                "type": "String"
              }
            ],
            "concreteType": "ConfigurableBlock",
            "plural": false,
            "selections": [
              v1,
              v2,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "slug",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "config",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "active",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": "articles",
            "name": "articlesPaginate",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "page",
                "variableName": "page",
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "pageSize",
                "value": 12,
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "plainSearch",
                "variableName": "search",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "section",
                "variableName": "section",
                "type": "ID"
              },
              {
                "kind": "Variable",
                "name": "states",
                "variableName": "states",
                "type": "[ArticleStateType]"
              }
            ],
            "concreteType": "ArticlesPagination",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalCount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "articles",
                "storageKey": null,
                "args": null,
                "concreteType": "Article",
                "plural": true,
                "selections": [
                  v1,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "section",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "title",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "authorName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "categoryName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "availableAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hidden",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isArticleOfDay",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isArticleOfHour",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isEvent",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "state",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "mainPageOrder",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "showInYandexNews",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "showInYandexZen",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "infostring",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "infostring_hot",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "mediaFiles",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MediaFile",
                    "plural": true,
                    "selections": [
                      v1
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "preview",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MediaFile",
                    "plural": false,
                    "selections": [
                      v2,
                      v1
                    ]
                  }
                ]
              }
            ]
          },
          v1
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c2691d00187913b53937ea0b28188261';
module.exports = node;



// WEBPACK FOOTER //
// src/components/articles/__generated__/ArticleList_Refetch_Query.graphql.js